<script>
export default {
    name:"AdminLogin",
    props:[],
    data: ()=>({
      errorMessage:null
    }),
    computed:{
      formAdmin:{
        get(){
          return this.$store.getters.formAdmin;
        },
        set(value){
          this.$store.commit("SET_FORM_ADMIN",value);
        }
      }
    },
    methods:{
      login(){
        this.$store.dispatch("auth").then((res)=>{

          if(res.status){
            this.$router.push("/admin/report");
          }else{
            this.errorMessage = res.message;
          }
        });
      }
    }
}
</script>
<template>
    <div id="AdminLogin">
        <div class="flex items-center justify-center">
        <div class="w-full max-w-md">
          <form class="bg-white shadow-lg rounded px-12 pt-6 pb-8 mb-4">
            <div
              class="text-gray-800 text-2xl flex justify-center border-b-2 py-2 mb-4"
            >
              Login
            </div>
            <div class="mb-4">
              <label
                class="block text-gray-700 text-sm font-normal mb-2"
                for="username"
              >
                email
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="email"
                v-model="formAdmin.email"
                type="text"
                required
                autofocus
                placeholder="email"
              />
            </div>
            <div class="mb-6">
              <label
                class="block text-gray-700 text-sm font-normal mb-2"
                for="password"
              >
                Password
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                v-model="formAdmin.password"
                type="password"
                placeholder="Password"
                name="password"
                required
                autocomplete="current-password"
              />
            </div>
            <div class="mb-3 text-red-500" v-if="errorMessage">{{errorMessage}}</div>
            <div class="flex items-center justify-between">
              <button class="px-4 py-2 rounded text-white inline-block shadow-lg bg-blue-500 hover:bg-blue-600 focus:bg-blue-700" type="submit" @click.prevent.stop="login()">Sign In</button>
              <!-- <a
                class="inline-block align-baseline font-normal text-sm text-blue-500 hover:text-blue-800"
                href="#"
              >
                Forgot Password?
              </a> -->
            </div>
          </form>
        </div>
      </div>
    </div>
</template>